import React, { useContext, useEffect, useRef, useState } from "react";
import { DailyPanditBookingAPI } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import { Link, useNavigate, useParams } from "react-router-dom";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
// import Batuk from "../../assets/images/new/Batuk2.png";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import {
  BlogCategoryList,
  CurrentBlogData,
} from "../../ApiServices/BlogApi/BlogAPI";
import { Helmet } from "react-helmet-async";
import "./blog.css";
import { LoaderContext } from "../../AuthContext/AuthContext";

const CommonBlogPage = () => {
  const user_id = localStorage.getItem("userID");
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [blogList, setblogList] = useState([]);
  const [dailyPanditPujaListData, setDailyPanditPujaListData] = useState([]);
  const [currentBlog, setCurrentBlog] = useState([]);
  const [searchBtnClick, setSearchClicked] = useState(false);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(9);
  const [hasMore, setHasMore] = useState(true);
  const isFetching = useRef(false);

  const navigate = useNavigate();
  const { setLoader, loader, activeCategory, setActiveCategory } =
    useContext(LoaderContext);
  const { slug } = useParams();

  const [categories, setCategories] = useState([]);
  // const [activeCategory, setActiveCategory] = useState('All');

  // Simulated items to filter
  const items = [
    { id: 1, name: "Caveman Item", category: "Caveman" },
    { id: 2, name: "Voodoo Item", category: "Voodoo" },
    { id: 3, name: "Fury Item", category: "Fury" },
    { id: 4, name: "Iceman Item", category: "Iceman" },
    { id: 5, name: "Another Caveman", category: "Caveman" },
  ];

  const GetCurrentBlog = async (params) => {
    if (isFetching.current) return;

    setLoader(true);
    isFetching.current = true;

    const response = await CurrentBlogData(params);

    if (response.ResponseCode === "0" && response.ResponseMessage === "list") {
      const blogs = response?.DATA || [];

      if (blogs.length === 0) {
        setHasMore(false); // No more data to load
      } else {
        setblogList((prev) => [...prev, ...blogs]);

        // If first time, set the current blog
        if (start === 0) {
          setCurrentBlog(
            blogs.find((item) => item.Blog_Slug === slug) || blogs[0]
          );
        }
      }
    }
    setLoader(false);
    isFetching.current = false;
  };
  const GetSearchedBlog = async (params) => {


    setLoader(true);


    const response = await CurrentBlogData(params);

    if (response.ResponseCode === "0" && response.ResponseMessage === "list") {
      const blogs = response?.DATA || [];


      setblogList(blogs);


    }
    setLoader(false);
    isFetching.current = false;
  };

  const handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 300 &&
      !loader &&
      hasMore
    ) {
      const newStart = start + 9;
      const newEnd = end + 9;
      setStart(newStart);
      setEnd(newEnd);
    }
  };

  useEffect(() => {
    GetCategories();
  }, [])
  useEffect(() => {
    GetCurrentBlog({
      START: start === 0 ? 0 : start + 1,
      END: end,
      WORD: '',
      EXTRA1: "",
      EXTRA2: "",
      EXTRA3: "",
      LANG_ID: "1",
      USER_ID: user_id,
    });
  }, [start, end]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [start, end, loader, hasMore]);

  useEffect(() => {
    if (searchBtnClick) {
      GetSearchedBlog({
        START: 0,
        END: 100,
        WORD: searchKeyWord,
        EXTRA1: "",
        EXTRA2: "",
        EXTRA3: "",
        LANG_ID: "1",
        USER_ID: user_id,
        BlogCatID: activeCategory === "All" ? null : activeCategory,
      });
      setSearchClicked(false);
    }
  }, [searchBtnClick]);

  const GetCategories = async () => {
    setLoader(true);
    const response = await BlogCategoryList();

    if (response.ResponseCode === "0" && response.ResponseMessage === "list") {
      setLoader(false);
      const categories = response?.DATA;
      const formattedStateList = [
        { value: "All", label: "All" },
        ...categories.map((value) => ({
          value: value.BlogCatID,
          label: value.BlogCatName,
        })),
      ];
      setCategories(formattedStateList);
    } else {
      setLoader(false);
    }
  };

  // const GetCurrentBlog = async (params) => {
  //   // debugger;
  //   setLoader(true);

  //   const response = await CurrentBlogData(params);

  //   if (response.ResponseCode === "0" && response.ResponseMessage === "list") {
  //     setLoader(false);
  //     const blogs = response?.DATA;
  //     setblogList(blogs);
  //     setCurrentBlog(blogs.find((item) => item.Blog_Slug === slug));
  //     //   if (blogs.length > 0) {
  //     //     if (location.state) {
  //     //       setCurrentBlog(location.state.blog);
  //     //     } else {
  //     //       setCurrentBlog(blogs[0]); // Set the first blog as the current blog
  //     //     }
  //     //   }
  //   } else {
  //     setLoader(false);
  //   }
  // };
  const filteredBlogs = blogList.filter(
    (data) =>
      data.BLOG_TITLE.toLowerCase().includes(searchKeyWord.toLowerCase()) &&
      data.BLOG_TITLE !== currentBlog?.BLOG_TITLE
  );

  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Remove <style> and <script> tags
    const styles = tempDiv.querySelectorAll("style, script");
    styles.forEach((el) => el.remove());

    return tempDiv.innerText || tempDiv.textContent || "";
  };


  const viewDetail = (puja) => {
    console.log("Navigating to details with puja:", puja);
    navigate("/services/daily-booking/puja-details", {
      state: { puja: puja },
    });
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category.value);
    setSearchClicked(true);
  };

  console.log("categories", categories);
  return (
    <>
      <section className="page-header" style={{ marginBottom: "2rem" }}>
        <div className="page-header__bg"></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">
            Spiritual Gyan -  Belief Redefined
          </h2>
        </div>
      </section>
      <Helmet>
        {/* Meta Title & Description */}
        <title>Spiritual Gyan - Insights, Rituals & Divine Knowledge</title>
        <meta
          name="description"
          content="Explore spiritual wisdom, rituals, and divine insights on our blog. Enhance your spiritual journey with meaningful knowledge and guidance."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.myomnamo.com/spiritual-gyan" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Spiritual Gyan - Insights, Rituals & Divine Knowledge"
        />
        <meta
          property="og:description"
          content="Explore spiritual wisdom, rituals, and divine insights on our blog. Enhance your spiritual journey with meaningful knowledge and guidance."
        />
        <meta
          property="og:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />
        <meta
          property="og:url"
          content="https://www.myomnamo.com/spiritual-gyan"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="MyOmNamo" />
        <meta property="og:locale" content="en_IN" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Spiritual Gyan - Insights, Rituals & Divine Knowledge"
        />
        <meta
          name="twitter:description"
          content="Explore spiritual wisdom, rituals, and divine insights on our blog. Enhance your spiritual journey with meaningful knowledge and guidance."
        />
        <meta
          name="twitter:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />

        {/* Schema Markup - Breadcrumbs */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Spiritual Gyan",
                item: "https://www.myomnamo.com/spiritual-gyan",
              },
            ],
          })}
        </script>

        {/* WebPage Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Spiritual Gyan - Insights, Rituals & Divine Knowledge",
            url: "https://www.myomnamo.com/spiritual-gyan",
            description:
              "Explore spiritual wisdom, rituals, and divine insights on our blog. Enhance your spiritual journey with meaningful knowledge and guidance.",
            publisher: {
              "@type": "Organization",
              name: "MyOmNamo",
            },
          })}
        </script>
      </Helmet>
      <div
        className="container "
        style={{ display: "flex", flexDirection: "column" }}
      >
        {/* Search Bar */}
        <div className="row ">
          <div className="col-md-6 mx-auto">
            <div
              className="search-box"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "1",
                maxWidth: "100%",
                marginRight: "10px",
                position: "relative", // Needed for absolute positioning
              }}
            >
              <input
                type="text"
                className="custom-search-input"
                placeholder="Search"
                value={searchKeyWord}
                onChange={(e) => setSearchKeyWord(e.target.value)}
                style={{
                  padding: "8px 35px 8px 10px", // Space for the icon on the right
                  width: "100%",
                }}
              />
              <span
                onClick={() => {
                  setActiveCategory("All");
                  setSearchClicked(true);
                }}
                style={{
                  position: "absolute",
                  right: "10px",
                  cursor: "pointer",
                  color: "#a52444",
                }}
              >
                <i className="fas fa-search"></i> {/* Font Awesome icon */}
              </span>
            </div>
          </div>
        </div>
        <div className="category-tabs-container">
          <ul className="nav justify-content-center border-bottom">
            {categories.map((cat, idx) => (
              <li className="nav-item " key={idx}>
                <button
                  className={`nav-link-blog category-tab-btn ${activeCategory === cat.value ? "active" : "InActive"
                    } `}
                  style={{ fontSize: "medium" }}
                  onClick={() => handleCategoryClick(cat)}
                >
                  {cat.label}
                </button>
              </li>
            ))}
          </ul>
          <br></br>
          {/* Optional: filtered content placeholder */}
          {/* <div className="mt-3">
            Showing results for: <strong>{activeCategory}</strong>
          </div> */}
        </div>
        {/* Puja Cards */}
        <section className="blog-one " style={{ paddingTop: "0px" }}>
          <div className="container">
            <div className="row gutter-y-30" style={{ justifyContent: "left" }}>
              {blogList?.length > 0 ? (
                blogList.map((blog, index) => (
                  <div className="col-md-4 col-lg-4 d-flex" key={index}>
                    <div
                      className="blog-card wow fadeInUp d-flex flex-column h-100"
                      data-wow-duration="1500ms"
                      data-wow-delay="100ms"
                      style={{ "--accent-color": "#FF5528" }}
                    >
                      <div className="blog-card__image" >
                        <img src={blog.BLOG_IMAGE} alt={blog.BLOG_TITLE} style={{ objectFit: 'contain ' }} />
                        <img src={blog.BLOG_IMAGE} alt={blog.BLOG_TITLE} style={{ objectFit: 'contain ' }} />.
                        <Link
                          to={`/spiritual-gyan/${blog.Blog_Slug}`}
                          className="blog-card__image__link"
                        >
                          <span className="sr-only">{blog.BLOG_TITLE}</span>
                        </Link>
                        <div className="blog-card__date">
                          <i className="icofont-ui-calendar"></i>
                          {blog.REG_DATE ? blog.REG_DATE : "Date not available"}
                        </div>
                      </div>

                      <div className="blog-card__content flex-grow-1 d-flex flex-column">
                        <ul
                          className="list-unstyled blog-card__meta"
                          style={{ fontSize: "12px" }}
                        >
                          <li>
                            <Link
                              style={{
                                marginRight: "15px",
                                color: "black",
                                fontSize: "12px",
                              }}
                            >
                              {blog.AutherName || "-"}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`/spiritual-gyan/${blog.Blog_Slug}`}
                              style={{ color: "black", fontSize: "12px" }}
                            >
                              <i class="fa-solid fa-clock"></i>{" "}
                              {blog.ReadingTime || 0}
                              <span className="text-decoration-none" style={{ marginLeft: "3px" }}>
                                Min
                              </span>
                            </Link>
                          </li>
                        </ul>

                        <h3
                          className="blog-card__title"
                          style={{ fontSize: "20px" }}
                        >
                          <Link to={`/spiritual-gyan/${blog.Blog_Slug}`}>
                            {blog.BLOG_TITLE}
                          </Link>
                        </h3>

                        <p
                          className="blog-card__text"
                          style={{ wordBreak: "break-word" }}

                        >
                          {stripHtml(blog.BLOG).length > 85
                            ? `${stripHtml(blog.BLOG).substring(0, 85)}...`
                            : stripHtml(blog.BLOG)}
                        </p>

                        <Link
                          to={`/spiritual-gyan/${blog.Blog_Slug}`}
                          className="blog-card__link mt-auto"
                        >
                          <span className="blog-card__link__front">
                            <span className="icofont-double-right"></span>
                          </span>
                          <span className="blog-card__link__back">
                            <span className="icofont-double-right"></span>
                            Read More
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : !loader ? (
                <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                  <img
                    src={Batuk}
                    alt="No Blogs Found"
                    className="img-fluid mb-3"
                    style={{ maxWidth: "200px" }}
                  />
                  <h5 className="fw-bold">No spiritual gyan available</h5>
                  {/* <p className="text-muted">Please explore our other services.</p> */}
                </div>
              ) : null}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CommonBlogPage;
